export default "__VITE_ASSET__B4Uj_ua4__"